import React, { useCallback, useState } from 'react';
import { Button, Space, message, Breadcrumb, Table, Spin } from 'antd';
import { 
  CardLayout, 
  TableWrapper, 
  CompanyEditModal, 
  FileViewerModal, 
  CrmListModal,
  CrmEditModal } from 'components/molecules';
import { addNewSearch } from 'utils/utils';
import { useLocation, useNavigate } from 'react-router';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import qs from 'query-string';
import { TotalNumMenu } from 'components/atoms';
import { useTableInfo, useCompany } from 'hooks';
import { INIT_PAGESIZE } from 'commons/constants';
import CompanySearchBox from './SearchBox'
import axios from 'axios';
import { endpoints } from 'services';
import { SERVER_URL } from 'commons/constants';
import moment from 'moment';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { isFileViewer } from 'utils/file-utils';
import { fetcher } from 'services';
import * as XLSX from 'xlsx';
import { SortOrder } from 'antd/lib/table/interface';
import { tableSortOrder } from 'utils/table-utils';

export interface  CompanyProps {}

const  Company = ({}:  CompanyProps): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  const navigate = useNavigate();
  const location = useLocation();  
  const { companyList, searchResult, refetch, companyFileUpdate, crmInsert } = useCompany();  

  /* ======================================================
   * variables
   * ====================================================== */
  const { open } = usePopupManager();
  const [isLoding, setIsLoading] = useState<boolean>(false);   

  const searchParams = qs.parse(location.search);  
  const columns: ColumnsType<CompanyListDto> = [
    {
      title: '기업번호',
      dataIndex: 'id',
      key: 'id',
      width: '80px',
      align: 'center',
    },  
    {
      title: '기업명',
      dataIndex: 'name',
      key: 'name',
      width: 'auto',
      align: 'left',   
      ellipsis: true,  
      sorter: true,
      sortOrder: tableSortOrder(searchParams.order as string, 'name', searchParams.reverse as string) as SortOrder,
      showSorterTooltip: false,          
    },  
    {
      title: 'CRM',
      key: 'crm',
      dataIndex: 'crm',
      width: '100px',
      align: 'center',
      onCell: (record) => {
        return {
            onClick: (e) => {
              e.stopPropagation();
            },
        };
      }, 
      render: (crm, record) => {
        return (
          <>
            <a onClick={(e) => {
              open(CrmListModal, {company_srl: record.id, company: record.name});
            }} >
              {crm}명
            </a> | <a onClick={(e) => {
              open(CrmEditModal, {
                id: 0,
                company_srl: record.id,
                company_name: record.name,
                fixCompany: true,
                onClose: (isOk, id) => {
                  if (isOk) {
                    refetch();
                  };
                },
              }); 
            }} >
              등록
            </a>
          </>
          
        )
      } 
    },
    {
     title: '프로젝트',
     key: 'project',
     dataIndex: 'project',
     width: '100px',
     align: 'center',
     sorter: true,
     sortOrder: tableSortOrder(searchParams.order as string, 'project', searchParams.reverse as string) as SortOrder,
     showSorterTooltip: false,        
     onCell: (record) => {
      return {
          onClick: (e) => {
            e.stopPropagation();
            if (record.project > 0)
              window.location.href = "/b2b/confirm?company=" + record.id;
          },
      };
    }, 
     render: (project, record) => {
      return (
        <>
          {project}건
        </>
      )
    } 
   },   
    {
      title: '성과백신',
      key: 'pml',
      dataIndex: 'pml',
      width: '100px',
      align: 'center',
      sorter: true,
      sortOrder: tableSortOrder(searchParams.order as string, 'pml', searchParams.reverse as string) as SortOrder,
      showSorterTooltip: false,       
      onCell: (record) => {
        return {
            onClick: (e) => {
              e.stopPropagation();
              if (record.pml > 0)
                window.location.href = "/b2c/pml?company=" + record.id;
            },
        };
      }, 
      render: (pml, record) => {
        return (
          <>
          {pml}건
          </>
        )
      } 
    },
    {
     title: '공개과정',
     key: 'b2c',
     dataIndex: 'b2c',
     width: '100px',
     align: 'center',
     sorter: true,
     sortOrder: tableSortOrder(searchParams.order as string, 'b2c', searchParams.reverse as string) as SortOrder,
     showSorterTooltip: false,        
     onCell: (record) => {
      return {
          onClick: (e) => {
            e.stopPropagation();
            if (record.b2c > 0)
              window.location.href = "/b2c/lecture?company=" + record.id;
          },
      };
    }, 
     render: (b2c, record) => {
      return (
        <>{b2c}건</>
      )
    }  
   },
   {
     title: '총매출',
     key: 'totalsale',
     dataIndex: 'totalsale',
     width: '120px',
     align: 'right', 
     sorter: true,
     sortOrder: tableSortOrder(searchParams.order as string, 'totalsale', searchParams.reverse as string) as SortOrder,
     showSorterTooltip: false,        
     render: (totalsale, record) => {
      return (
        totalsale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      )
    }     
   },
   {
     title: '포인트',
     key: 'point',
     dataIndex: 'point',
     width: '120px',
     align: 'right', 
     sorter: true,
     sortOrder: tableSortOrder(searchParams.order as string, 'point', searchParams.reverse as string) as SortOrder,
     showSorterTooltip: false,        
     onCell: (record) => {
      return {
          onClick: (e) => {
            e.stopPropagation();
            window.location.href = "/customer/company/point/" + record.id;              
          },
      };
    },       
     render: (point, record) => {
      return (
        <a>{point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
      )
    }    
   },  
   {
     title: '선납금',
     key: 'money',
     dataIndex: 'money',
     width: '120px',
     align: 'right',
     sorter: true,
     sortOrder: tableSortOrder(searchParams.order as string, 'money', searchParams.reverse as string) as SortOrder,
     showSorterTooltip: false,      
     onCell: (record) => {
      return {
          onClick: (e) => {
            e.stopPropagation();
            window.location.href = "/customer/company/money/" + record.id;              
          },
      };
    },      
     render: (money, record) => {
      return (
        <a>{money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a>
      )
    }  
   },  
   {
     title: '통장사본',
     dataIndex: 'account_number_file_id',
     key: 'account_number_file_id',
     width: '100px',
     align: 'center',
     render: (account_number_file_id, record) => {
      return (      
        <Space>
          {(account_number_file_id > 0) && (
            <>
              <Button shape="round" onClick={(e) => {e.stopPropagation(); onDownload(account_number_file_id, record.account_number_file_name);}} icon={<DownloadOutlined />} size='small' style={{padding:'3px'}}/>
              {isFileViewer(record.account_number_file_name) && (<Button shape="round" onClick={(e) => {e.stopPropagation(); onOpenFileViewer(account_number_file_id, record.account_number_file_name, record.id, 'account', true);}} icon={<SearchOutlined />} size='small' style={{padding:'3px'}}/>)}            
            </>
          )}        
        </Space>  
      )
    } 
   },    
   {
     title: '사업자등록증',
     dataIndex: 'business_number_file_id',
     key: 'business',
     width: '100px',
     align: 'left',
     render: (business_number_file_id, record) => {
      return (      
        <Space>
          {(business_number_file_id > 0) && (
            <>
              <Button shape="round" onClick={(e) => {e.stopPropagation(); onDownload(business_number_file_id, record.business_number_file_name);}} icon={<DownloadOutlined />} size='small' style={{padding:'3px'}}/>
              {isFileViewer(record.business_number_file_name) && (<Button shape="round" onClick={(e) => {e.stopPropagation(); onOpenFileViewer(business_number_file_id, record.business_number_file_name, record.id, 'business', true);}} icon={<SearchOutlined />} size='small' style={{padding:'3px'}}/>)}            
            </>
          )}        
        </Space>  
      )
    }  
   },  
  ];

  /* ======================================================
   * events
   * ====================================================== */   
  const onClickRegister = () => {
    open(CompanyEditModal, {
      id: 0,
      onClose: (isOk) => {
        if (isOk) { refetch() }
      },
    });     
  }

  const onNewExcelDownload = () => {
    setIsLoading(true); 
    axios({
      url: SERVER_URL + endpoints.company.downloadexcel,
      method: 'post',
      responseType: 'arraybuffer',
      params: searchParams,
    })
    .then((response) => {
      const fileName = "고객_고객사_" + moment().format('YYYYMMDD_HHmmss')+".xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}`);
      link.style.cssText = 'display:none';
      document.body.appendChild(link);
      link.click();
      setIsLoading(false); 
    })
    .catch(() => {
      message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
      setIsLoading(false); 
    });     
  }    

  const onChangePageInfo = (pageNo: number, pageSize: number) => {
    navigate({
      ...location,
      search: addNewSearch(location.search, { pageNo, pageSize }),
    });
  };    

  const onChangeSorters = (sorter: any)  => {
    const { order, field } = sorter;
    if (!!order) {
      const reverse = order === 'ascend' ? 'Y' : '';
    
      navigate({
        ...location,
        search: addNewSearch(location.search, { pageNo: 1, order:field, reverse }),
      });  
    } else {
      navigate({
        ...location,
        search: addNewSearch(location.search, { pageNo: 1, order:null, reverse:null }),
      });        
    }  
  };

  const onDownload = (fileSeq:number, fileName: string): void => {
    axios({
      url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
      method: 'get',
      responseType: 'blob',
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
      });
    };

    const onOpenFileViewer = (fileId: number, fileName: string, seq: number, gubun: string, editable: boolean) => {
      open(FileViewerModal, {
        fileid: fileId,
        filename: fileName,
        seq: seq,
        gubun: gubun,
        editable: editable,
        onClose: (isOk, seq, gubun, files) => {
          if (isOk) {
            if (gubun === 'account') {
              companyFileUpdate({
                id: seq,
                account_fileData: files,
              }) 
            } else if (gubun === 'business') {
              companyFileUpdate({
                id: seq,
                business_fileData: files,
              }) 
            }
          };
        },
      });   
     }    

 const onRowClick = useCallback((record, index) => {
  return {
    onClick: () => {
     open(CompanyEditModal, {
       id: Number(record.id),
       onClose: (isOk) => {
          if (isOk) { refetch() }
       },
     }); 
    },
  };
 }, []);
 
  /* ======================================================
   * hooks
   * ====================================================== */
  const { pagination, onTableChange } = useTableInfo({
    pageInfo: {
      pageNo: Number(searchParams.pageNo) || 1,
      pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
    },
    datas: companyList,
    totalCount: searchResult.totalCount,
    onChangePageInfo,
    onChangeSorters,
  });

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>고객</Breadcrumb.Item>
        <Breadcrumb.Item>고객사</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <CompanySearchBox />
          <Spin spinning={isLoding} tip="처리중입니다. 잠시만 기다려 주세요." size="large">
            <TotalNumMenu totalNum={searchResult.totalCount} useRegister useExcelDownload onUseRegister={onClickRegister} onDownloadExcel={onNewExcelDownload}/>
            <TableWrapper isSearch={!!searchParams.search || !!searchParams.lecturer_type || !!searchParams.lecturer_category}>
              <Table
                tableLayout="fixed"
                dataSource={companyList}
                columns={columns}
                pagination={pagination}
                onChange={onTableChange}
                onRow={onRowClick}
                style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
                className="columnCenterFixTable clickable"
                sortDirections={["descend", "ascend"]}
                showSorterTooltip={false}
                rowKey={'id'}
              />
            </TableWrapper>   
          </Spin>         
        </Space>                
    </CardLayout>
  )
};

export default  Company;    